/* app/ui/track/motion-solution */

import { listen } from 'Util/core';
import * as track from 'Util/track';

/**
 * @typedef {import('../../../util/track.js').EventDetails} EventDetails
 */

const selectors = Object.freeze({
	book: '.js-track__book'
});

const dataAttributes = Object.freeze({
	location: 'data-book-location',
});

/**
 * Initialise the CED Solution tracking module.
 */
function init() {
	_initEvents();
}

/**
 * Bind event listeners for the CED Solution tracking module.
 */
function _initEvents() {
	listen(selectors.book, 'click', _bookClickEvent);
}

/**
 * Callback for the solution click event
 *
 * @param  {MouseEvent} e
 */
function _bookClickEvent(e) {
	/** @type {EventDetails} */
	debugger;
	const eventObj = {
		category: 'Book Now',
		label: e.target.href,

		ga4EventName: 'book_now_click',
		ga4EventLabel: e.target.href
	};

	const location = _getLocation(e.target);

	if (location) {
		eventObj.action = location;
		eventObj.ga4EventAction = location;
	}
	debugger;
	track.event(eventObj);
}

/**
 * Get the name of a solution based on the event target of a click event.
 *
 * @param  {HTMLElement} $target
 *
 * @return {string | null} The name of the current solution
 */
function _getLocation($target) {
	const location = $target.getAttribute(dataAttributes.location);

	return location;
}

const Track = {
	init
};

export { Track };
